import { Card, CardContent, Stack, Typography, Box } from "@mui/material";
import React from "react";

const DashboardCard = ({ title, Icon, ...otherProps }) => {
  return (
    <Card
      component={Stack}
      justifyContent="center"
      alignItems="center"
      height={200}
      sx={(theme) => ({
        cursor: "pointer",
        borderRadius: "16px",
        background: `linear-gradient(white, white) padding-box, linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.dark} 100%) border-box`,
        border: "0.5px solid transparent",
        boxShadow: `0 4px 16px ${
          theme.palette.mode === "dark"
            ? "rgba(28, 202, 255, 0.15)"
            : "rgba(22, 54, 131, 0.15)"
        }`,
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: `0 8px 24px ${
            theme.palette.mode === "dark"
              ? "rgba(28, 202, 255, 0.25)"
              : "rgba(22, 54, 131, 0.25)"
          }`,
          background: `linear-gradient(white, white) padding-box, linear-gradient(135deg, ${theme.palette.primary.light} 30%, ${theme.palette.primary.main} 70%, ${theme.palette.primary.dark} 100%) border-box`
        }
      })}
      {...otherProps}
    >
      <CardContent component={Stack} alignItems="center" spacing={2}>
        <Box
          sx={(theme) => ({
            background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.dark} 100%)`,
            borderRadius: "50%",
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 4px 12px ${
              theme.palette.mode === "dark"
                ? "rgba(28, 202, 255, 0.3)"
                : "rgba(22, 54, 131, 0.3)"
            }`
          })}
        >
          <Icon
            fontSize="large"
            sx={{
              color: "white",
              fontSize: 40
            }}
          />
        </Box>
        <Typography
          sx={(theme) => ({
            background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.dark} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textAlign: "center",
            fontWeight: 700,
            fontSize: 18
          })}
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default DashboardCard;
